import { Payfirma } from './payfirma.minified';

/**
 * Handle AmEx modal
 */
$(function() {
    $('#paymentForm select[name="card_type"]').change(function() {
        if ($(this).val() === 'AmEx') {
            $('.payment-modal').show();
            $(this).val('');
        }
    });
    $('.payment-modal-inside').click(function(e) {
        e.stopPropagation();
    });
    $('.payment-modal').click(function() {
        $(this).hide();
    });
});

/**
 * Handle form submission
 */
$('#paymentForm').validate({
    rules: {
        amount: {
            required: true,
            minlength: 1,
            number: true
        },
        card_number: {
            required: true,
            creditcard: true
        },
        cvv2: {
            required: true,
            number: true,
            minlength: 3,
            maxlength: 4
        }
    },
    submitHandler: function(form, event) {
        event.preventDefault();

        // Disable the form while it's being submitted
        $('#paymentForm button').attr('disabled', 'disabled');

        var card_number = $('input[name="card_number"]').val();
        var card_expiry_month = $('select[name="card_expiry_month"]').val();
        var card_expiry_year = $('input[name="card_expiry_year"]').val();
        var cvv2 = $('input[name="cvv2"]').val();

        var first_name = $('input[name="first_name"]').val();
        var last_name = $('input[name="last_name"]').val();
        var email = $('input[name="email"]').val();
        var company = $('input[name="company"]').val();
        var address1 = $('input[name="address1"]').val();
        var city = $('input[name="city"]').val();
        var province = $('input[name="province"]').val();
        var country = $('input[name="country"]').val();
        var postal_code = $('input[name="postal_code"]').val();
        var invoice_id = $('input[name="invoice_id"]').val();
        var amount = $('input[name="amount"]').val();

        var key = '2d2d2d2d2d424547494e205055424c4943204b45592d2d2d2d2d4d494942496a414e42676b71686b6947397730424151454641414f43415138414d49494243674b43415145413537594f3237636137692b6b4a636d456f546848506c4d677777714d7a6c58516f555574544e2b774c5936384c49684152364a4c6c6b55717152706a68374238323846417976782b2b46534147615435596b664354782f4d414166436c334b3269334743663441524b3757554377516b436b7664506b5a39444a423739354b3166514969716569572f4e3758723353696e4b4158486966433736517345337745792f50735a5235677654457646356859656452784d4e632b417750616f63387830756339584577797a676c73346c4c33717a2b4a4a4e32314b2f6871486d6e53774e6e33303770776b336639365667524b7a38784264434c4563786e693371626c72656d486334346f7848637444742f76466a334e392b676c2f53702b737044386965334f66534d36634f7532596c55396178387a486f48634a6e2f3443525a4d686c344a726a38486b4144506c5249356a2b747a774944415141422d2d2d2d2d454e44205055424c4943204b45592d2d2d2d2d';

        // Run the payfirma payment
        new Payfirma(key,
            {
                'card_number': card_number,
                'card_expiry_month': card_expiry_month,
                'card_expiry_year': card_expiry_year,
                'cvv2': cvv2
            },
            {
                'first_name': first_name,
                'last_name': last_name,
                'email': email,
                'company': company,
                'address1': address1,
                'city': city,
                'province': province,
                'country': country,
                'postal_code': postal_code,
                'invoice_id': invoice_id,
                'amount': amount
            },
            'https://ugh68mzh0m.execute-api.us-east-1.amazonaws.com/jostleme/',

            function(response) {
                let responseData = JSON.parse(response);
                let queryString = $.param(responseData);

                if (responseData.error != undefined) {
                    window.location.href = '/payment/error';
                } else if (responseData.result === 'declined') {
                    window.location.href = '/payment/failure?' + queryString;
                } else {
                    window.location.href = '/payment/complete?' + queryString;
                }
            }
        );
    }
});

$('.currency input').on('keyup blur', function() {
    if($(this).val()) {
        $(this).parent().addClass('has-value');
    } else {
        $(this).parent().removeClass('has-value');
    }
});
